import React from 'react'
import HomeCategoryCard from '../../../customer/pages/Home/HomeCategory/HomeCategoryCard'
import HomeCategoryTable from './HomeCategoryTable'
import { useAppSelector } from '../../../Redux Toolkit/Store'
import ResponsiveContainer from '../../../components/layout/ResponsiveContainer' // ✅ add

const ShopByCategoryTable = () => {
  const { homePage } = useAppSelector((store) => store)

  return (
    <ResponsiveContainer maxWidth="xl"> {/* centered, adapts by breakpoint */}
      <HomeCategoryTable categories={homePage.homePageData?.shopByCategories} />
    </ResponsiveContainer>
  )
}

export default ShopByCategoryTable
